module.exports = __webpack_public_path__ + "static/img/member.64315920.png";